import { useNavigate } from "react-router-dom";
import { ArrowRight, LogOut } from "lucide-react";
import SiteLogo from "../../components/SiteLogo";
import HeaderNotificationBell from "../../components/HeaderNotificationBell";
import NavProfileAvatar from "../../components/NavProfileAvatar";

export default function old1_PublicSiteNav({ currentUser, setCurrentUser, ariaLabel = "Main navigation" }) {
  const navigate = useNavigate();
  const hasActiveSession = Boolean(currentUser && typeof currentUser === "object" && currentUser.email);
  const workspacePath =
    currentUser?.role === "hiring-manager" || currentUser?.role === "recruiter"
      ? "/hiring-dashboard"
      : "/applicant-home";

  return (
    <nav className="landing-nav jw-public-nav" aria-label={ariaLabel}>
      <div className="landing-nav-shell jw-public-nav__shell">
        <SiteLogo />
        {hasActiveSession ? (
          <div className="user-actions jw-public-session-actions">
            <NavProfileAvatar
              currentUser={currentUser}
              onClick={() => navigate(workspacePath)}
              ariaLabel="Open your home page"
            />
            <div className="user-manage-menu jw-public-session-menu">
              <HeaderNotificationBell currentUser={currentUser} />
              <button
                type="button"
                className="jw-public-button jw-public-button--text jw-public-session-sign-out"
                onClick={() => setCurrentUser(null)}
              >
                <LogOut className="jw-public-icon" aria-hidden />
                Sign out
              </button>
            </div>
          </div>
        ) : (
          <div className="nav-buttons landing-nav-actions">
            <button
              type="button"
              className="jw-public-button jw-public-button--text landing-nav-login"
              onClick={() => navigate("/old1/signin")}
            >
              Sign in
            </button>
            <button
              type="button"
              className="jw-public-button jw-public-button--primary landing-nav-cta"
              onClick={() => navigate("/old1/signup")}
            >
              Sign up
              <ArrowRight className="jw-public-icon" aria-hidden="true" />
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
